import axios from "axios"

import { baseApiUrl } from "../General/Constants"

import localStorageProvider from '../Providers/LocalStorageProvider';

export default () => {
  return {
    create: async (file: any | null | undefined) => {
      const url = `${baseApiUrl}/customer/private/file/upload?type=image&thumbnail=1`
      const token = localStorageProvider.getItem("token")
      const auth = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }

      var bodyFormData = new FormData()
      bodyFormData.append("file", file)

      const { data } = await axios.post(url, bodyFormData, auth)
      return data
    },
  }
}
